import React, {useEffect, useState, memo} from "../../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import {Modal, Pagination, Button, Badge, Spin, message, Row} from "../../../../__snowpack__/pkg/antd.js";
import useTable from "../../../hooks/mutations/useTable/index.js";
import request from "../../../utils/request/index.js";
import GnAlert from "../../../components/GnAlert/index.js";
import GnTable from "../../../components/GnTable/index.js";
import moment from "../../../../__snowpack__/pkg/moment-timezone.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
import {useRequest} from "../../../../__snowpack__/pkg/ahooks.js";
export const ExportRecordModal = memo((props) => {
  const {visible, exportParams, searchParams, onHandleCancelCallback, onHandleSuccessCallback} = props;
  const {formatMessage} = useIntl();
  const [loading, setLoading] = useState(false);
  const {search, tableProps, pagination} = useTable((params) => {
    params.types = searchParams;
    return request.post("/saas/file-warehouse/search", {...params});
  });
  const downloadLink = (record) => {
    if ("download" in document.createElement("a")) {
      const eLink = document.createElement("a");
      eLink.download = record.name;
      eLink.style.display = "none";
      eLink.href = record.downloadUrl;
      document.body.appendChild(eLink);
      eLink.click();
      URL.revokeObjectURL(eLink.href);
      document.body.removeChild(eLink);
    }
  };
  const formatExportStatus = (type) => {
    switch (type) {
      case "CREATED":
        return {title: "create", color: "#FFCC0F"};
      case "PENDING":
        return {title: "ExportINProcess", color: "#FFCC0F"};
      case "FINISHED":
        return {title: "ExportFinished", color: "#66BE75"};
      case "FAILED":
        return {title: "ExportFailed", color: "#F5222D"};
    }
  };
  const formatType = {
    WAREHOUSE_ALL: formatMessage({id: "warehouseLevelAllPages"}),
    WAREHOUSE_PART: formatMessage({id: "warehouseLevelClickToCheck"}),
    SHELF_ALL: formatMessage({id: "locationLevelAllPages"}),
    SHELF_PART: formatMessage({id: "locationLevelClickToCheck"})
  };
  const {run: handleExportRequest, data} = useRequest((params) => {
    return request.post("/saas/file-warehouse/warehouseInventory/export-data", params);
  }, {
    manual: true,
    onSuccess: (data2) => {
      if (data2.failMessage) {
        message.warning(data2.failMessage);
      } else {
        search.submit();
      }
      setLoading(false);
    }
  });
  useEffect(() => {
    if (visible && exportParams) {
      try {
        setLoading(true);
        handleExportRequest(exportParams);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    } else if (visible) {
      search.submit();
    }
  }, [visible]);
  return /* @__PURE__ */ React.createElement(Modal, {
    visible,
    title: formatMessage({id: "exportRecords"}),
    width: 1050,
    footer: null,
    onCancel: () => {
      onHandleCancelCallback && onHandleCancelCallback();
    }
  }, /* @__PURE__ */ React.createElement(Spin, {
    spinning: loading
  }, /* @__PURE__ */ React.createElement(GnAlert, {
    message: formatMessage({id: "theFileWillBeDisplayedSynchronously"}),
    type: "warning",
    showIcon: true,
    style: {marginBottom: 16}
  }), /* @__PURE__ */ React.createElement(Row, {
    justify: "end",
    style: {marginBottom: 16}
  }, /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    loading: tableProps.loading,
    style: {marginLeft: "10px"},
    onClick: () => {
      search.submit();
    }
  }, formatMessage({id: "Refresh"}))), /* @__PURE__ */ React.createElement(GnTable, {
    scroll: {x: "max-content", y: 450},
    rowKey: "id",
    ...tableProps,
    pagination: false,
    loading: tableProps.loading
  }, /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "ExportTime"}),
    dataIndex: "createDatetime",
    render: (text) => text && moment(text).format("DD-MM-YYYY HH:mm") || "-"
  }), /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "Creator"}),
    width: 150,
    dataIndex: "operatorName"
  }), /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "ExportContent"}),
    dataIndex: "name"
  }), /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "exportProgress"}),
    dataIndex: "rateOfProcess",
    width: 150,
    render: (text) => text && text + "%"
  }), /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "exportType"}),
    dataIndex: "type",
    width: 135,
    render: (text) => formatType[text] ?? "-"
  }), /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "status"}),
    dataIndex: "status",
    render: (text, record, index) => text && formatExportStatus(text) && /* @__PURE__ */ React.createElement(Badge, {
      color: formatExportStatus(text).color,
      text: formatMessage({id: formatExportStatus(text).title})
    }) || "-"
  }), /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "Action"}),
    key: "action",
    render: (text, record) => /* @__PURE__ */ React.createElement(Button, {
      type: "link",
      size: "small",
      style: {padding: 0},
      disabled: record.status !== "FINISHED",
      onClick: () => {
        downloadLink(record);
      }
    }, formatMessage({id: "download"}))
  })), /* @__PURE__ */ React.createElement(FlexWrapper, {
    style: {marginTop: "26px"}
  }, /* @__PURE__ */ React.createElement(Pagination, {
    ...pagination
  }))));
});
export default ExportRecordModal;
const Wrapper = styled.div``;
const FlexWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`;
